import React from "react";
import { Sun, Lightbulb, ShieldCheck, Zap } from "lucide-react";

const ITEMS = [
  { icon: Sun, label: "Solar", img: "/img/rooftop-solar.png" },
  { icon: Lightbulb, label: "Lighting", img: "/img/solar-street-light.png" },
  { icon: ShieldCheck, label: "CCTV", img: "/img/cctv-security.png" },
  { icon: Zap, label: "Power", img: "/img/high-mast-lighting.png" },
];

export default function CapabilityStrip() {
  return (
    <div className="px-5 md:px-7 pb-2">
      <div className="kicker mb-2">Capabilities</div>
      <div className="grid grid-cols-4 gap-2.5">
        {ITEMS.map((it) => (
          <div key={it.label} className="relative rounded-xl overflow-hidden border border-soft aspect-[4/5]">
            <img src={it.img} alt={it.label} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0b1f3b]/95 via-[#0b1f3b]/40 to-transparent" />
            <div className="absolute top-2 left-2 w-7 h-7 rounded-md bg-white/95 grid place-items-center"><it.icon className="w-3.5 h-3.5 text-navy" /></div>
            <div className="absolute bottom-2 inset-x-2 text-white text-[12px] font-bold tracking-wide">{it.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
